import { useEffect } from "react";
import Lenis from "lenis";
import { Navbar } from "../components/landing/Navbar";
import { Hero } from "../components/landing/Hero";
import { EditorialMarquee } from "../components/landing/Marquee";
import { VideoSection } from "../components/landing/VideoSection";
import { Manifesto } from "../components/landing/Manifesto";
import { Portfolio } from "../components/landing/Portfolio";
import { Piercing } from "../components/landing/Piercing";
import { Reviews } from "../components/landing/Reviews";
import { InstagramStrip } from "../components/landing/InstagramStrip";
import { Location } from "../components/landing/Location";
import { QuoteForm } from "../components/landing/QuoteForm";
import { FloatingWhatsApp } from "../components/landing/FloatingWhatsApp";
import { Footer } from "../components/landing/Footer";
import { trackEvent } from "../lib/api";

export default function LandingPage() {
  useEffect(() => {
    if (!sessionStorage.getItem("diggy_visit")) {
      sessionStorage.setItem("diggy_visit", "1");
      trackEvent("visit", document.referrer);
    }
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    const onAnchor = (e) => {
      if (e.target.closest('a[href*="wa.me"]')) trackEvent("whatsapp_click");
      const a = e.target.closest('a[href^="#"]');
      if (a) {
        const el = document.querySelector(a.getAttribute("href"));
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -80 });
        }
      }
    };
    document.addEventListener("click", onAnchor);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      document.removeEventListener("click", onAnchor);
    };
  }, []);

  return (
    <div className="bg-[#0A0A0A]" data-testid="landing-page">
      <div className="grain-overlay" />
      <Navbar />
      <Hero />
      <EditorialMarquee />
      <VideoSection />
      <Manifesto />
      <Portfolio />
      <Piercing />
      <Reviews />
      <InstagramStrip />
      <QuoteForm />
      <Location />
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
